export const BFF_HOST: string | undefined = process.env.REACT_APP_BFF_HOST;

export const BFF_PATHNAME: string | undefined = process.env.REACT_APP_BFF_PATHNAME;

export const BFF_FOLDER_PATH: string | undefined = process.env.REACT_APP_BFF_FOLDER_PATH;

export const BFF_PERSON_PATH: string | undefined = process.env.REACT_APP_BFF_PERSON_PATH;

export const BFF_LEAD_PATH: string | undefined = process.env.REACT_APP_BFF_LEAD_PATH;

export const BFF_COMPANY_PATH: string | undefined = process.env.REACT_APP_BFF_COMPANY_PATH;

export const BFF_RULES_PATH: string | undefined = process.env.REACT_APP_BFF_RULES_PATH;

export const BFF_FIND_ADVISORS_ENDPOINT: string | undefined = process.env.REACT_APP_BFF_FIND_ADVISORS_ENDPOINT;

export const BFF_IDENTIFY_ENDPOINT: string | undefined = process.env.REACT_APP_BFF_IDENTIFY_ENDPOINT;

export const BFF_RECOMMANDATION_PATH: string | undefined = process.env.REACT_APP_BFF_RECOMMANDATION_PATH;

export const BFF_GET_OFFERS_PATH: string | undefined = process.env.REACT_APP_BFF_GET_OFFERS_PATH;

export const BFF_REQUEST_CONTACT_ENDPOINT: string | undefined = process.env.REACT_APP_BFF_REQUEST_CONTACT_ENDPOINT;

export const BFF_FIND_BY_SIRET_ENDPOINT: string | undefined = process.env.REACT_APP_BFF_FIND_BY_SIRET_ENDPOINT;

export const BFF_PRICING_ENDPOINT: string | undefined = process.env.REACT_APP_BFF_PRICING_ENDPOINT;

export const BFF_PRICING_NEEDS_ENDPOINT: string | undefined = process.env.REACT_APP_BFF_PRICING_NEEDS_ENDPOINT;

export const BFF_INITIALIZE_ENDPOINT: string | undefined = process.env.REACT_APP_BFF_INITIALIZE_ENDPOINT;

export const BFF_VERIFY_ELIGIBILITY_ENDPOINT: string | undefined =
    process.env.REACT_APP_BFF_VERIFY_ELIGIBILITY_ENDPOINT;
